<template>
	<div class="content-box" style="padding-bottom: 0px;">
		<div class="element-wrapper" style="padding-bottom: 0px;">
			<h6 class="element-header">{{ t('titleCustomerSendOptions','titleCustomerSendOptions') }}</h6>				
			<div class="element-box col-lg-6 col-md-12 col-sm-12">
				<div class="element-info">
					<div class="row">
						<div class="col-12 col-sm-6 col-md-8">
							<div class="element-info-with-icon">
								<div class="element-info-icon">
									<span class="os-icon os-icon-mail"></span>
								</div>
								<div class="element-info-text">
									<h5 class="element-inner-header">{{ t('headerCustomerSendOptionsSearch','headerCustomerSendOptionsSearch') }}</h5>
									<div class="element-inner-desc">{{ t('customerSendOptionsFormDesc', 'customerSendOptionsFormDesc') }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<form v-on:submit.prevent="updateSentOptions">
					<div class="col-12 row m-0 p-0">
						<div class="col-md-6 col-lg-12 mt-4" style="padding: 0px;">
							<div class="element-info p-0">
								<h6>Upload Settings</h6>
							</div>
							<div class="row col-lg-12 mb-1 block-input-row">
								<div class="col-4">
								{{ t('customerSendOptUserDocumentTypeLabel', 'customerSendOptUserDocumentTypeLabel') }}
								</div>
								<div class="col-7">
								<b-form-select class="form-control text-capitalize" v-model="customersData.selectedUserDocType">
									<option :value="null" disabled>{{ t('selectDocumentText','selectDocumentText') }}</option>
									<option v-for="(docType, key) in userDocTypes" :value="docType.id" :key="key">{{ docType.name }}</option>
								</b-form-select>
								</div>
							</div>
							<div class="row col-lg-12 mb-1 block-input-row" style="display: flex; align-items: center;">
								<div class="col-4">
									{{ t('customerSendOptCSVfileLabel', 'customerSendOptCSVfileLabel') }}
								</div>
								<div class="col-7">
									<b-form-file style="text-align: left;" accept=".csv" v-model="updateSendOptionsCSV" required></b-form-file>
								</div>
							</div>
							<div class="row col-lg-12 mb-3 block-input-row" style="display: flex; align-items: center;">
								<div class="col-4">
									{{ t('customerSendOptFirstRowContainsHeadings', 'customerSendOptFirstRowContainsHeadings') }}
								</div>
								<div class="col-7 text-center">
									<b-form-checkbox v-model="customersData.headings" :value="1" :unchecked-value="0"></b-form-checkbox>
								</div>
							</div>
							<div class="element-info p-0">
								<h6>Customer information (with at most one email address per line)</h6>
							</div>
							<div class="row col-lg-12 mb-1 block-input-row" style="display: flex; align-items: center;">
								<div class="col-4">
									{{ t('customerSendOptCustomerRefLabel', 'customerSendOptCustomerRefLabel') }}
								</div>
								<div class="col-7">
									<b-form-select class="form-control text-capitalize" v-model="customersData.customerRef">
										<option :value="null" selected>{{ t('customerSendOptNotRequired', 'customerSendOptNotRequired') }}</option>
										<option v-for="columnOption in columnOptions" :key="columnOption.value" :value="columnOption.value">{{columnOption.text}}</option>
									</b-form-select>
								</div>
							</div>
							<div class="row col-lg-12 mb-3 block-input-row" style="display: flex; align-items: center;">
								<div class="col-4">
									{{ t('customerSendOptEmailAddressLabel', 'customerSendOptEmailAddressLabel') }}
								</div>
								<div class="col-7">
									<b-form-select class="form-control text-capitalize" v-model="customersData.emailAddress">
										<option :value="null" selected>{{ t('customerSendOptNotRequired', 'customerSendOptNotRequired') }}</option>
										<option v-for="columnOption in columnOptions" :key="columnOption.value" :value="columnOption.value">{{columnOption.text}}</option>
									</b-form-select>
								</div>
							</div>
							<div class="element-info p-0">
								<h6>Customer Delivery Options</h6>
							</div>
							<div class="row col-lg-12 mb-1 block-input-row" style="display: flex; align-items: center;">
								<div class="col-4">
									{{ t('customerSendOptSendDataLabel', 'customerSendOptSendDataLabel') }}
								</div>
								<div class="col-7">
									<b-form-select class="form-control text-capitalize" v-model="customersData.sendData">
										<option :value="null" selected>{{ t('customerSendOptNotRequired', 'customerSendOptNotRequired') }}</option>
										<option v-for="columnOption in columnOptions" :key="columnOption.value" :value="columnOption.value">{{columnOption.text}}</option>
									</b-form-select>
								</div>
							</div>
							<div class="row col-lg-12 mb-1 block-input-row" style="display: flex; align-items: center;">
								<div class="col-4">
									{{ t('customerSendOptEmailLink', 'customerSendOptEmailLink') }}
								</div>
								<div class="col-7">
									<b-form-select class="form-control text-capitalize" v-model="customersData.emailLink">
										<option :value="null" selected>{{ t('customerSendOptNotRequired', 'customerSendOptNotRequired') }}</option>
										<option v-for="columnOption in columnOptions" :key="columnOption.value" :value="columnOption.value">{{columnOption.text}}</option>
									</b-form-select>
								</div>
							</div>
							<div class="row col-lg-12 mb-1 block-input-row" style="display: flex; align-items: center;">
								<div class="col-4">
									{{ t('customerSendOptEmailDoc', 'customerSendOptEmailDoc') }}
								</div>
								<div class="col-7">
									<b-form-select class="form-control text-capitalize" v-model="customersData.emailDoc">
										<option :value="null" selected>{{ t('customerSendOptNotRequired', 'customerSendOptNotRequired') }}</option>
										<option v-for="columnOption in columnOptions" :key="columnOption.value" :value="columnOption.value">{{columnOption.text}}</option>
									</b-form-select>
								</div>
							</div>
							<div class="row col-lg-12 mb-1 block-input-row" style="display: flex; align-items: center;">
								<div class="col-4">
									{{ t('customerSendOptFaxLabel', 'customerSendOptFaxLabel') }}
								</div>
								<div class="col-7">
									<b-form-select class="form-control text-capitalize" v-model="customersData.fax">
										<option :value="null" selected>{{ t('customerSendOptNotRequired', 'customerSendOptNotRequired') }}</option>
										<option v-for="columnOption in columnOptions" :key="columnOption.value" :value="columnOption.value">{{columnOption.text}}</option>
									</b-form-select>
								</div>
							</div>
							<div class="row col-lg-12 mb-1 block-input-row" style="display: flex; align-items: center;">
								<div class="col-4">
									{{ t('customerSendOptPostLabel', 'customerSendOptPostLabel') }}
								</div>
								<div class="col-7">
									<b-form-select class="form-control text-capitalize" v-model="customersData.post">
										<option :value="null" selected>{{ t('customerSendOptNotRequired', 'customerSendOptNotRequired') }}</option>
										<option v-for="columnOption in columnOptions" :key="columnOption.value" :value="columnOption.value">{{columnOption.text}}</option>
									</b-form-select>
								</div>
							</div>
							<div class="row col-lg-12 mb-1 block-input-row" style="display: flex; align-items: center;">
								<div class="col-4">
									{{ t('customerSendOptLiveOnlineLabel', 'customerSendOptLiveOnlineLabel') }}
								</div>
								<div class="col-7">
									<b-form-select class="form-control text-capitalize" v-model="customersData.liveOnline">
										<option :value="null" selected>{{ t('customerSendOptNotRequired', 'customerSendOptNotRequired') }}</option>
										<option v-for="columnOption in columnOptions" :key="columnOption.value" :value="columnOption.value">{{columnOption.text}}</option>
									</b-form-select>
								</div>
							</div>
							<div class="row col-lg-12 mb-1 block-input-row" style="display: flex; align-items: center;">
								<div class="col-4">
									{{ t('customerSendOptLockLabel', 'customerSendOptLockLabel') }}
								</div>
								<div class="col-7">
									<b-form-select class="form-control text-capitalize" v-model="customersData.lock">
										<option :value="null" selected>{{ t('customerSendOptNotRequired', 'customerSendOptNotRequired') }}</option>
										<option v-for="columnOption in columnOptions" :key="columnOption.value" :value="columnOption.value">{{columnOption.text}}</option>
									</b-form-select>
								</div>
							</div>
							<div class="row col-lg-12 mb-1 block-input-row" style="display: flex; align-items: center;">
								<div class="col-4">
									{{ t('customerSendOptRemindLabel', 'customerSendOptRemindLabel') }}
								</div>
								<div class="col-7">
									<b-form-select class="form-control text-capitalize" v-model="customersData.remind">
										<option :value="null" selected>{{ t('customerSendOptNotRequired', 'customerSendOptNotRequired') }}</option>
										<option v-for="columnOption in columnOptions" :key="columnOption.value" :value="columnOption.value">{{columnOption.text}}</option>
									</b-form-select>
								</div>
							</div>
							<div class="row col-lg-12 mb-1 block-input-row" style="display: flex; align-items: center;">
								<div class="col-4">
									{{ t('customerSendOptNotifyLabel', 'customerSendOptNotifyLabel') }}
								</div>
								<div class="col-7">
									<b-form-select class="form-control text-capitalize" v-model="customersData.notify">
										<option :value="null" selected>{{ t('customerSendOptNotRequired', 'customerSendOptNotRequired') }}</option>
										<option v-for="columnOption in columnOptions" :key="columnOption.value" :value="columnOption.value">{{columnOption.text}}</option>
									</b-form-select>
								</div>
							</div>						
						</div>
						<div class="col-lg-12 row pt-3" style="padding-right: 90px;">
							<div class="col-12" style="text-align: right; padding-right: 0px;">
								<button v-if="!isBusy" :disabled="!updateSendOptionsCSV || !customersData.selectedUserDocType || !customersData.customerRef" class="btn btn-primary" type="submit" >{{ t('uploadBtn','uploadBtn') }}</button>
								<b-button v-else variant="primary" disabled>
									<b-spinner small type="grow"></b-spinner>
									{{ t('UpdateBtn','UpdateBtn') }}
								</b-button>
							</div>
						</div>
						<transition name="fade">
							<ResponseInfo v-if="(getResponseInfo.responseName == 'customerSendOptions') && (getResponseInfo.status == 'error')" class="mt-3"/>
						</transition>
					</div>
				</form>
			</div>
		</div>
		<!-- Results Modal -->
		<ModalSummaryResults :report="getResponseInfo.report"/>
		<div v-if="overlayBackgroundDisplay" class="modal-backdrop show"></div>
	</div>				
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { clientShortName } from '@/helpers/clientShortName.js'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ModalSummaryResults from '@/components/Customers_Send_Options/ModalSummaryResults.vue'

export default {
	name: 'CustomerSendOptions',
	components: {
    ModalSummaryResults,
    ResponseInfo
  },
	data() {
		return {
			isBusy: false,
			overlayBackgroundDisplay: false,
			columnOptions: [
				{ text: 'A Column', value: 1},
				{ text: 'B Column', value: 2},
				{ text: 'C Column', value: 3},
				{ text: 'D Column', value: 4},  
				{ text: 'E Column', value: 5},
				{ text: 'F Column', value: 6},
				{ text: 'G Column', value: 7},
				{ text: 'H Column', value: 8},
				{ text: 'I Column', value: 9},
				{ text: 'J Column', value: 10},
				{ text: 'K Column', value: 11},
				{ text: 'L Column', value: 12},
				{ text: 'M Column', value: 13},
				{ text: 'N Column', value: 14},
				{ text: 'O Column', value: 15},
				{ text: 'P Column', value: 16},
				{ text: 'Q Column', value: 17},
				{ text: 'R Column', value: 18},
				{ text: 'S Column', value: 19}
			],
			updateSendOptionsCSV: null,
			customersData: {
				headings: 0,
				customerRef: null,
				emailAddress: null,
				selectedUserDocType: null,
				sendData: null,
				emailLink: null,
				emailDoc: null,
				fax: null,
				post: null,
				liveOnline: null,
				lock: null,
				remind: null,
				notify: null
			}
		}
	},
	methods: {
		// NS-9835 SP Update Delivery options
		updateSentOptions() {
			let formData = new FormData();
			this.isBusy = true
			let form = JSON.stringify(this.customersData)
			formData.append('form', form)
			formData.append('file', this.updateSendOptionsCSV)

			this.$store.dispatch('customerStore/updateSendOptionsByCsv', formData)
			.then(() => {
				this.isBusy = false
				let responseStatus = this.getResponseInfo.status
				if(responseStatus != 'error'){
					this.overlayBackgroundDisplay = true
					this.$root.$emit('bv::show::modal', 'summaryResultsModal')
				}
			})
			this.updateSendOptionsCSV = null
		},
	},
	created() {
		this.$store.dispatch('customerStore/getUserDocumentTypes')
	},
	computed: {
		userDocTypes() {
			return this.$store.getters['customerStore/getUserDocumentTypes']
		},
		...mapGetters(['allTemplateDetails', 'getUserDetails', 'getResponseInfo'])
	}
}
</script>

<style scoped>

.block-input-row {
	align-items: center;
	text-align: right;
	margin-top: 5px;
}
	
</style>